// Standalone, publisher-neutral page for the CTVBuyer Advertiser Terms. Gives
// the terms their own shareable URL (/advertiser-terms) so they aren't only
// reachable through the step-1 wizard overlay. Both surfaces render the same
// AdvertiserTermsContent, so the copy stays in one place.

import React from 'react';
import AdvertiserTermsContent from '../../components/self-service/AdvertiserTermsContent';

const AdvertiserTermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-2xl mx-auto bg-white border border-slate-200 rounded-xl shadow-sm p-8">
        <h1 className="text-2xl font-semibold text-slate-900 tracking-tight mb-6">
          CTVBuyer Advertiser Terms
        </h1>
        <AdvertiserTermsContent />
      </div>
    </div>
  );
};

export default AdvertiserTermsPage;
